/**
 * @generated SignedSource<<181a2844f19811967a175c2a899887e7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraVersionWarningConfigState = "DISABLED" | "ENABLED" | "NOT_APPLICABLE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type ui_softwareReleasesVersionIssueWarningController_IssuesWarningCountProvider_jiraVersion$data = {
  readonly warningConfig: {
    readonly failingBuild: JiraVersionWarningConfigState;
    readonly openPullRequest: JiraVersionWarningConfigState;
    readonly openReview: JiraVersionWarningConfigState;
    readonly unreviewedCode: JiraVersionWarningConfigState;
  } | null | undefined;
  readonly " $fragmentType": "ui_softwareReleasesVersionIssueWarningController_IssuesWarningCountProvider_jiraVersion";
};
export type ui_softwareReleasesVersionIssueWarningController_IssuesWarningCountProvider_jiraVersion$key = {
  readonly " $data"?: ui_softwareReleasesVersionIssueWarningController_IssuesWarningCountProvider_jiraVersion$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesVersionIssueWarningController_IssuesWarningCountProvider_jiraVersion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_softwareReleasesVersionIssueWarningController_IssuesWarningCountProvider_jiraVersion",
  "selections": [
    {
      "concreteType": "JiraVersionWarningConfig",
      "kind": "LinkedField",
      "name": "warningConfig",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "openPullRequest"
          },
          "action": "NONE",
          "path": "warningConfig.openPullRequest"
        },
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "openReview"
          },
          "action": "NONE",
          "path": "warningConfig.openReview"
        },
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "unreviewedCode"
          },
          "action": "NONE",
          "path": "warningConfig.unreviewedCode"
        },
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "failingBuild"
          },
          "action": "NONE",
          "path": "warningConfig.failingBuild"
        }
      ]
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "a12dea52160bb6c6b5d0ff127f4a7b36";

export default node;
